<template>
  <div>
    <div v-if="!form">
      <div class="alert alert-primary">
        {{ $t('companyFormAdminView.mlumatYklnir') }}
      </div>
    </div>
    <div v-else>
      <div class="page-header">
        <div class="page-header-left">
          <ol class="breadcrumb ml-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'welcome' }">
                <feather type="home" />
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'vendorManagementDashboard' }">
                {{ $t('companyFormAdminView.vendorManagement') }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'vendorManagementFormList' }">
                {{ $t('companyFormAdminView.tdarkDyrlndirmFormalar') }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name: 'vendorManagementFormManage', params:{id: form.id}}">
                {{ form.name }}
              </router-link>
            </li>
          </ol>
        </div>
      </div>

      <div class="card">
        <div
          v-if="editMain"
          class="card-body"
        >
          <form @submit.prevent="saveForm">
            <div class="mb-3">
              <label>{{ $t('companyFormEdit.formannAd') }}</label>
              <div>
                <input
                  v-model.trim="form.name"
                  type="text"
                  class="form-control"
                  required
                >
              </div>
            </div>
            <div class="mb-3">
              <label>{{ $t('companyFormEdit.tyinat') }}</label>
              <div>
                <select
                  v-model.trim="form.profileType"
                  class="form-control"
                  required
                  disabled
                >
                  <option value="SUPPLIER">
                    {{ $t('companyFormEdit.malVXidmtlrlBal') }}
                  </option>
                  <option value="LOGISTIC">
                    {{ $t('companyFormEdit.logistiklrN') }}
                  </option>
                  <option value="TRUCK">
                    {{ $t('companyFormEdit.trSahiblriN') }}
                  </option>
                </select>
              </div>
            </div>


            <div
              v-if="form.profileType==='SUPPLIER'"
              class="mb-3"
            >
              <label>{{ $t('companySearch.faliyytSahlri') }}</label>
              <div>
                <Multiselect
                  v-model="sectors"
                  name="form_sectors"
                  :options="sectorList"
                  :multiple="true"
                  :label="$t('newTRKRequest.name')"
                  track-by="id"
                  :min="1"
                  :taggable="false"
                />
              </div>
            </div>

            <div class="mb-3">
              <label>{{ $t('companyFormEdit.qeydlr') }} </label>
              <div>
                <textarea
                  v-model.trim="form.description"
                  type="text"
                  class="form-control"
                  required
                />
              </div>
            </div>

            <div class="mb-3">
              <button
                type="submit"
                class="btn btn-success mr-2"
              >
                {{ $t('sectorSelectionModal.yaddaSaxla') }}
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click="editMain= false;"
              >
                {{ $t('companyProfile.lvEt2') }}
              </button>
            </div>
          </form>
        </div>
        <div
          v-else
          class="card-body"
        >
          <h4>{{ form.name }}</h4>
          <div v-html="formDescription" />

          <div class="my-2">
            <div
              v-for="s in sectors"
              class="mb-2"
            >
              - {{ s.name }}
            </div>
          </div>

          <div class="mt-3">
            <button
              class="btn btn-sm btn-light-dark mr-3"
              @click="editMain=true"
            >
              {{ $t('companyFormAdminView.dyi') }}
            </button>
            <router-link
              :to="{name: 'vendorManagementFormManage', params:{id: form.id}}"
              class="btn btn-sm btn-light-success "
            >
              {{ $t('companyFormEdit.idaretm') }}
            </router-link>
          </div>
        </div>
      </div>


      <div class="card my-4">
        <div class="card-header text-danger text-center">
          {{ $t('companyFormEdit.tdarkFormasnYaradarknBirTkMrhldnBlmVYaBirNeMrhldnB') }}
        </div>

        <div class="card-body">
          <b-tabs
            pills
            small
            card
          >
            <b-tab
              v-for="(s,i) in sections"
              :key="s.id"
              :title="s.title"
              :active="i===0"
            >
              <div class="mb-0">
                <div class="mb-3">
                  <button
                    class="btn btn-sm btn-outline-primary m-2"
                    @click="renameSection(s)"
                  >
                    {{ $t('companyFormEdit.mrhlninAdnDyi') }}
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger m-2"
                    @click="deleteSection(s)"
                  >
                    {{ $t('companyFormEdit.mrhlniSil') }}
                  </button>
                </div>
                <div class="row">
                  <template v-for="(i,j) in sectionInputs[s.id]">
                    <VendorManagementInputView
                      :key="i.hash"
                      :input="i"
                      :is-admin="true"
                      @edit="editBlock(i)"
                      @delete="deleteBlock(i)"
                      @copy="copyBlock(s.id, j+1 ,i)"
                      @addAfter="addNewBlock(s.id, j+1 )"
                    />
                  </template>
                </div>
                <div
                  v-if="sectionInputs[s.id].length <1"
                  class="alert alert-light"
                >
                  <feather
                    type="info"
                    size="20"
                  />
                  {{ $t('companyFormEdit.buMrhlNBlokLavEdilmyib') }}
                </div>

                <div class="mt-3">
                  <div
                    class="addNewBlockButton"
                    @click="addNewBlock(s.id, sectionInputs[s.id].length+1)"
                  >
                    <feather
                      type="plus"
                      size="12"
                    />
                    {{ $t('companyFormEdit.yeniBlok2') }}
                  </div>
                </div>
              </div>
            </b-tab>
            <template #tabs-end>
              <button
                class=" ml-3 btn btn-sm btn-success text-white"
                @click.prevent="createSection"
              >
                <span class="f-w-600">{{ $t('companyFormEdit.yeniMrhl') }}</span>
              </button>
            </template>
          </b-tabs>
        </div>
        <div class="card-footer">
          <button
            v-if="form.status === 'DRAFT'"
            type="button"
            class="btn btn-primary mr-2"
            @click.prevent="markReady"
          >
            {{ $t('companyFormEdit.formaHazrdr') }}
          </button>
          <router-link
            :to="{name: 'vendorManagementFormManage', params:{id: form.id}}"
            class="btn btn-success "
          >
            {{ $t('companyFormEdit.idaretm') }}
          </router-link>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-form-create-input"
      centered
      :title="$t('companyFormEdit.yeniBlok')"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="createInput">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>{{ $t('companyFormEdit.blokTipi') }}</label>
            <div>
              <select
                v-model.trim="newInput.inputType"
                class="form-control"
                required
              >
                <option
                  v-for="(v,k) in blockTypes"
                  :key="k"
                  :value="k"
                >
                  {{ v }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label>{{ $t('companyFormEdit.l') }}</label>
            <div>
              <select
                v-model.number="newInput.settings.size"
                class="form-control"
                required
              >
                <option value="12">
                  100%
                </option>
                <option value="9">
                  75%
                </option>
                <option value="6">
                  50%
                </option>
                <option value="4">
                  33%
                </option>
                <option value="3">
                  25%
                </option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="newInput.inputType">
          <div class="mb-3">
            <label>{{ $t('companyFormEdit.balq') }}</label>
            <div>
              <input
                v-model.trim="newInput.title"
                type="text"
                class="form-control"
                required
              >
            </div>
          </div>
          <div class="mb-3">
            <label>{{ $t('companyFormEdit.qeydlr') }}</label>
            <div>
              <textarea
                v-model.trim="newInput.description"
                class="form-control"
                rows="3"
              />
            </div>
          </div>

          <div
            v-if="newInput.inputType==='select'"
            class="mb-3"
          >
            <label>{{ $t('companyFormEdit.seimlrHrStrd1CavabVariantDaxilEdin') }}</label>
            <div>
              <textarea
                v-model.trim="newInput.settings.values"
                class="form-control"
                rows="3"
                required
              />
            </div>
          </div>

          <div
            v-if="newInput.inputType=== 'select'"
            class="row"
          >
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="newInput.settings.multiple"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.birNeSeimEdilBilr') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div
            v-if="newInput.inputType=== 'file'"
            class="row"
          >
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="newInput.settings.multiple"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.birNeFaylYklnBilr') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="newInput.visible"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.grnn') }}
                </b-form-checkbox>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div
                v-if="newInput.inputType !== 'info'"
                class="checkbox"
              >
                <b-form-checkbox
                  v-model="newInput.required"
                  name="checkboxRequired"
                >
                  {{ $t('companyFormEdit.doldurulmasMtlqdir') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>


          <div class="mb-3">
            <button
              type="submit"
              class="btn btn-success"
            >
              {{ $t('companyFormEdit.yarat') }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="modal-form-edit-input"
      centered
      :title="$t('companyFormEdit.blokRedaktsi')"
      class="theme-modal"
      :hide-footer="true"
    >
      <form
        v-if="editInput"
        @submit.prevent="saveInput"
      >
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>{{ $t('companyFormEdit.blokTipi') }}</label>
            <div>
              <select
                v-model.trim="editInput.inputType"
                class="form-control"
                readonly
              >
                <option
                  v-for="(v,k) in blockTypes"
                  :key="k"
                  :value="k"
                >
                  {{ v }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label>{{ $t('companyFormEdit.l') }}</label>
            <div>
              <select
                v-model.number="editInput.settings.size"
                class="form-control"
                required
              >
                <option value="12">
                  100%
                </option>
                <option value="9">
                  75%
                </option>
                <option value="6">
                  50%
                </option>
                <option value="4">
                  33%
                </option>
                <option value="3">
                  25%
                </option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="editInput">
          <div class="mb-3">
            <label>{{ $t('companyFormEdit.balq') }}</label>
            <div>
              <input
                v-model.trim="editInput.title"
                type="text"
                class="form-control"
                required
              >
            </div>
          </div>
          <div class="mb-3">
            <label>{{ $t('companyFormEdit.qeydlr') }}</label>
            <div>
              <textarea
                v-model.trim="editInput.description"
                class="form-control"
                rows="3"
              />
            </div>
          </div>

          <div
            v-if="editInput.inputType==='select'"
            class="mb-3"
          >
            <label>{{ $t('companyFormEdit.seimlrHrStrd1CavabVariantDaxilEdin') }}</label>
            <div>
              <textarea
                v-model.trim="editInput.settings.values"
                class="form-control"
                rows="3"
                required
              />
            </div>
          </div>

          <div
            v-if="editInput.inputType=== 'select'"
            class="row"
          >
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="editInput.settings.multiple"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.birNeSeimEdilBilr') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div
            v-if="editInput.inputType=== 'file'"
            class="row"
          >
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="editInput.settings.multiple"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.birNeFaylYklnBilr') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="checkbox">
                <b-form-checkbox
                  v-model="editInput.visible"
                  name="checkboxVisible"
                >
                  {{ $t('companyFormEdit.grnn') }}
                </b-form-checkbox>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div
                v-if="editInput.inputType !== 'info'"
                class="checkbox"
              >
                <b-form-checkbox
                  v-model="editInput.required"
                  name="checkboxRequired"
                >
                  {{ $t('companyFormEdit.doldurulmasMtlqdir') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <button
              type="submit"
              class="btn btn-success"
            >
              {{ $t('sectorSelectionModal.yaddaSaxla') }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  companyFormAction,
  createFormInput,
  createFormSection, deleteFormInput, deleteFormSection,
  getMyForm, handleErrors,
  saveForm,
  saveFormInput, saveFormSection
} from "@/repositories/VendorManagementRepository";
import VendorManagementInputView from "@/pages/scc/vendorManagement/builder/VendorManagementInputView.vue";
import {getWorkingSectors} from "@/repositories/GeneralDataRepository";

import Multiselect from 'vue-multiselect'

export default {
  components: {VendorManagementInputView, Multiselect},
  data() {
    return {
      mediaBase: mediaBase,
      form: null,
      editMain: false,
      sectors: [],
      sections: [],
      inputs: [],
      sectionInputs: [],

      newInput: {
        sectionId: 0,
        listOrder: 0,
        inputType: '',
        title: '',
        description: '',
        required: false,
        visible: false,
        settings: {}
      },
      editInput: null,
      blockTypes: this.$t("blockTypes"),
      sectorList: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    formDescription: function () {
      if (this.form && this.form.description) {
        return this.form.description.replace(/(?:\r\n|\r|\n)/g, '<br>');
      } else {
        return '';
      }
    }
  },
  watch: {
    inputs: {
      deep: true,
      handler() {
        this.calculateSectionInputs();
      }
    },
    sections: {
      deep: true,
      handler() {
        this.calculateSectionInputs();
      }
    },
  },
  mounted() {

    this.getFormDetails();

    getWorkingSectors(this.$i18n.locale).then(ws => {
      this.sectorList = ws.filter(s => s.parent === null);
    })

  },
  methods: {

    calculateSectionInputs() {

      let map = {};

      this.sections.forEach((s) => {
        map[s.id] = [];
      })

      this.inputs.forEach((i) => {
        i.hash = JSON.stringify(i);
        map[i.companyFormSectionId].push(i);
      })

      this.sectionInputs = map;
    }
    ,
    getFormDetails() {

      getMyForm(this.token, this.$route.params.id, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          this.form = data.form;
          this.sectors = data.sectors;
          this.sections = data.sections;
          this.inputs = data.inputs;
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, data, null);
        }
      })

    },


    saveForm() {
      if (this.sectors.length < 1 && this.form.profileType === 'SUPPLIER') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("enAziFlyytShs"),
          icon: 'error'
        });
        return;
      }
      let sectors = this.sectors.map(function (elem) {
        return elem.id;
      }).join(",");

      saveForm(this.token, this.form.id, this.form.name, this.form.description, sectors).then(data => {

        if (data.code === 200) {
          this.editMain = false;
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },

    createSection() {
      this.$swal({
        title: this.$t("companyFormEdit.newStage"),
        icon: 'question',
        text: this.$t("companyFormEdit.newStageText"),
        input: 'text',
        inputValue: '',
        showCancelButton: true,
        confirmButtonText: this.$t("generalModal.buttonCreate"),
        cancelButtonText: this.$t("generalModal.buttonCancel"),
      }).then((result) => {
        if (result.value) {
          createFormSection(this.token, this.form.id, this.sections.length + 1, result.value).then(data => {

            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    createInput() {
      createFormInput(this.token, this.form.id, this.newInput.sectionId, this.newInput.inputType, this.newInput.title,
          this.newInput.description, this.newInput.listOrder, this.newInput.required, this.newInput.visible, this.newInput.settings).then(data => {

        if (data.code === 200) {

          this.addNewBlock(0, 0);
          this.getFormDetails();
          this.$bvModal.hide('modal-form-create-input')

        } else {
          handleErrors(this.$swal, data, null);
        }

      })
    },
    saveInput() {
      saveFormInput(this.token, this.editInput.id, this.form.id, this.editInput.companyFormSectionId, this.editInput.inputType, this.editInput.title,
          this.editInput.description, this.editInput.listOrder, this.editInput.required, this.editInput.visible, this.editInput.settings).then(data => {

        if (data.code === 200) {

          this.editInput = null;
          this.getFormDetails();
          this.$bvModal.hide('modal-form-edit-input')

        } else {
          handleErrors(this.$swal, data, null);
        }

      })
    },

    addNewBlock(sectionId, listOrder) {

      this.newInput = {
        sectionId: sectionId,
        listOrder: listOrder,
        inputType: '',
        title: '',
        description: '',
        required: false,
        visible: false,
        settings: {
          size: 12
        }
      };

      this.$bvModal.show('modal-form-create-input')

    },

    copyBlock(sectionId, listOrder, input) {

      let settings = JSON.parse(input.settings);

      this.newInput = {
        sectionId: sectionId,
        listOrder: listOrder,
        inputType: input.inputType,
        title: input.title,
        description: input.description,
        required: input.required,
        visible: input.visible,
        settings: {
          size: settings.size
        }
      };

      this.$bvModal.show('modal-form-create-input')

    },

    editBlock(input) {

      let block = {...input};
      console.log(block);
      block.settings = JSON.parse(block.settings);
      this.editInput = block;
      this.$bvModal.show('modal-form-edit-input')
    },

    deleteBlock(input) {

      this.$swal({
        title: input.title,
        icon: 'question',
        text: this.$t("general.dltConfirm"),
        showCancelButton: true,
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("slm"),
      }).then((result) => {
        if (result.value) {
          deleteFormInput(this.token, input.id).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    renameSection(section) {

      this.$swal({
        title: section.title,
        icon: 'question',
        text: this.$t("ynAdiDxlEdin"),
        input: 'text',
        inputValue: section.title
      }).then((result) => {
        if (result.value) {
          saveFormSection(this.token, section.id, this.form.id, result.value, section.listOrder).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    deleteSection(section) {

      this.$swal({
        title: section.title,
        icon: 'question',
        text: this.$t("general.dltConfirm"),
        showCancelButton: true,
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("slm"),
      }).then((result) => {
        if (result.value) {
          deleteFormSection(this.token, section.id).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    markReady() {
      if (this.inputs.length < 1) {
        this.$swal.fire({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("frmdHcBrSh"),
              icon: 'warning'
            }
        )
        return;
      }

      let emptySectors = Object.values(this.sectionInputs).filter(s => s.length < 1);
      if (emptySectors.length >0) {
        this.$swal.fire({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("hrBrMrhldAzi"),
              icon: 'warning'
            }
        )
        return;
      }

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("companyFormEdit.modalText"),
        showCancelButton: true,
        confirmButtonText: this.$t("supplierOutgoingVendorRequest.hazrdr"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'ready', '').then(data => {
            if (data.code === 200) {
              this.$router.push({name: 'vendorManagementFormManage', params: {id: this.form.id}})
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },
  }
}
</script>
<style scoped lang="scss">

.addNewBlockButton {
  padding: 20px;
  border: 1px dotted #474e50;
  background: #e9ecec;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background: #a6afaf;
  }
}
</style>
